var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5455 2.74432V4.58203C25.5455 4.71729 25.4358 4.82706 25.3005 4.82706H0.699663C0.564407 4.82706 0.454634 4.71729 0.454634 4.58203V2.74432C0.454634 1.22857 1.68321 0 3.19895 0H22.8012C24.317 0 25.5455 1.22857 25.5455 2.74432ZM0.45459 14.5057V6.12571C0.45459 5.99045 0.564363 5.88068 0.699618 5.88068H25.3005C25.4357 5.88068 25.5455 5.99045 25.5455 6.12571V14.5057C25.5455 16.0214 24.3169 17.25 22.8012 17.25H3.19891C1.68316 17.25 0.45459 16.0214 0.45459 14.5057Z",
    fill: "url(#paint0_linear_2264_242)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47327 12.5896H3.58193C3.29966 12.5896 3.07031 12.3608 3.07031 12.078C3.07031 11.7953 3.29917 11.5664 3.58193 11.5664H6.47278C6.75505 11.5664 6.9844 11.7953 6.9844 12.078C6.9844 12.3608 6.75554 12.5896 6.47278 12.5896H6.47327Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2264_242",
    x1: 0.454589,
    y1: 17.25,
    x2: 26.4006,
    y2: 15.8502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.7bd6daca116a38f523e8306dfb05c2e2.svg";
export { ForwardRef as ReactComponent };